import React from 'react';
import { WrapperSeamless } from '../../layout-components';
import Table from '../../components/tables/table';
import { Button } from '@material-ui/core';
import { useGetList, usePutData } from '../../hooks';
import { Link } from 'react-router-dom';
import * as Api from '../../service';
import useStore from '../../context';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

const query = {
  limit: 10,
  sort: 'id',
  order: 'asc'
};

export default function Products() {
  const { setRemove, lang } = useStore();
  const [items, total, refresh, setItems] = useGetList(
    Api.productsReq.getAll,
    query
  );
  const orderCallback = usePutData(Api.productsReq, refresh);

  const rows = items?.map((item) => (
    <>
      <td className="text-left">
        <div className="font-size-sm">{item[`title_${lang}`]}</div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm">{item?.order}</div>
      </td>
      <td className="text-right">
        <Link to={`/products/create/${item.id}`}>
          <Button className="btn-neutral-first mx-1 shadow-none d-30 border-0 p-0 d-inline-flex align-items-center justify-content-center">
            <EditIcon color="primary" />
          </Button>
        </Link>

        <Button
          onClick={() =>
            setRemove(() => () =>
              Api.productsReq.delete(item.id).then(refresh)
            )
          }
          className="btn-neutral-danger mx-1 shadow-none d-30 border-0 p-0 d-inline-flex align-items-center justify-content-center">
          <DeleteIcon color="danger" />
        </Button>
      </td>
    </>
  ));

  return (
    <WrapperSeamless>
      <Table
        title="Products"
        subTitle="Order"
        items={items}
        setItems={setItems}
        total={total}
        titles
        rows={rows}
        noDrag
        orderCallback={orderCallback}
        createLink="products/create"
      />
    </WrapperSeamless>
  );
}
